import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { usePreventBackNavigation } from "./usePreventBackNavigation";

const PaymentExpired = () => {
  // Prevent back navigation from this page
  usePreventBackNavigation(true);

  // Prevent page refresh and any navigation attempts
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue =
        "Payment session expired. This page cannot be left for security reasons.";
      return event.returnValue;
    };

    // Prevent right-click context menu
    const handleContextMenu = (event) => {
      event.preventDefault();
    };

    // Prevent certain keyboard shortcuts
    const handleKeyDown = (event) => {
      // Prevent F5, Ctrl+R, Ctrl+F5 (refresh)
      if (
        event.key === "F5" ||
        (event.ctrlKey && event.key === "r") ||
        (event.ctrlKey && event.key === "R") ||
        (event.ctrlKey && event.shiftKey && event.key === "R")
      ) {
        event.preventDefault();
      }

      // Prevent Alt+Left (back), Alt+Right (forward)
      if (
        event.altKey &&
        (event.key === "ArrowLeft" || event.key === "ArrowRight")
      ) {
        event.preventDefault();
      }

      // Prevent Backspace navigation (when not in input field)
      if (
        event.key === "Backspace" &&
        event.target.tagName !== "INPUT" &&
        event.target.tagName !== "TEXTAREA"
      ) {
        event.preventDefault();
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <div className="p-10 text-center">
      <h1 className="text-2xl font-bold text-red-600">
        Payment Session Expired
      </h1>
      <p className="mt-4">
        Please restart the payment process from the beginning.
      </p>
    </div>
  );
};

export default PaymentExpired;
